import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Image } from "react-bootstrap";
import "../Styles/Dashboard.css";
import TopDeals from "./TopDeals";
import WhatsAppChatBot from "./WhatsAppChatBot";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

const categories = [
  { img: require("../Images/fertilizers.png"), label: "FERTILIZERS" },
  { img: require("../Images/pesticides.png"), label: "PESTICIDES" },
  { img: require("../Images/soils.png"), label: "SOILS" },
  { img: require("../Images/seeds.png"), label: "SEEDS" },
  { img: require("../Images/equipment.png"), label: "EQUIPMENT" },
  { img: require("../Images/gardens.png"), label: "GARDENS" },
];

export default function Dashboard({ handleCartClick, handleLikeClick, user }) {
  const navigate = useNavigate();

  const handleCardClick = (label) => {
    switch (label) {
      case "FERTILIZERS":
        navigate("/nutrition");
        break;
      case "PESTICIDES":
        navigate("/protection");
        break;
      case "SOILS":
        navigate("/soils");
        break;
      case "SEEDS":
        navigate("/heritage-seeds");
        break;
      case "EQUIPMENT":
        navigate("/equipment");
        break;
      case "GARDENS":
        navigate("/gardening");
        break;
      default:
        break;
    }
  };

  return (
    <Container fluid className="dashboard-container text-center">
      <Row className="mt-4">
        <Col>
          <h2 className="dashboard-title">TELL US WHAT YOU NEED</h2>
        </Col>
      </Row>

      <Row className="justify-content-center mt-3">
  {categories.map((item, index) => {
    const colClass = isMobile ? "col-4" : "col-12 col-md-6 col-lg-2"; // For mobile, show 2 items per row
    return (
      <Col key={index} className={`mb-3 ${colClass}`}>
        <Card
          className="text-center shadow-lg category-card h-100 d-flex flex-column"
          onClick={() => handleCardClick(item.label)}
          style={{ cursor: "pointer" }}
        >
          <Card.Img variant="top" src={item.img} className="category-image" />
          <Card.Body className="d-flex flex-column justify-content-end">
            <Card.Title>{item.label}</Card.Title>
          </Card.Body>
        </Card>
      </Col>
    );
  })}
</Row>

      <TopDeals handleCartClick={handleCartClick} handleLikeClick={handleLikeClick} user={user} />
      <WhatsAppChatBot />
    </Container>
  );
}
